import { Button } from '@/components/common';
import { ReviewDialog } from '@/features/monitoring/review-modal/ReviewDialog';
import { TransactionDetailField } from '@/features/monitoring/review-modal/TransactionDetailsTab';
import { formatRevenueAmount, type RevenueTransaction } from './transaction-types';

const labels = {
  payment: 'Outgoing payment',
  incoming: 'Incoming payment',
  conversion: 'Conversion',
};
const money = (value: string, currency: string) => `${formatRevenueAmount(value)} ${currency}`;

export function RevenueTransactionDetails({
  transaction,
  onClose,
}: {
  transaction: RevenueTransaction | null;
  onClose: () => void;
}) {
  if (!transaction) return null;
  const t = transaction;
  return (
    <ReviewDialog
      isOpen
      onClose={onClose}
      title="Transaction Details"
      ariaLabel={`Transaction details ${t.transaction_cod ?? t.transaction_id ?? t.id}`}
    >
      <div className="flex-1 overflow-y-auto px-6 py-4">
        <TransactionDetailField label="Transaction Code" value={t.transaction_cod ?? '—'} />
        <TransactionDetailField label="Transaction ID" value={t.transaction_id ?? '—'} />
        <TransactionDetailField label="Type" value={labels[t.type]} />
        <TransactionDetailField label="Status" value={t.status} />
        <TransactionDetailField label="Client" value={t.client_name} />
        <TransactionDetailField label="Client ID" value={t.client_id} />
        <TransactionDetailField
          label={t.type === 'conversion' ? 'Sell Amount' : 'Amount'}
          value={money(t.amount, t.currency_code)}
        />
        {t.type === 'conversion' && t.buy_amount !== null && t.buy_currency !== null && (
          <TransactionDetailField label="Buy Amount" value={money(t.buy_amount, t.buy_currency)} />
        )}
        <TransactionDetailField
          label={t.type === 'conversion' ? 'FX Margin' : 'Fee Applied'}
          value={money(t.revenue, t.revenue_currency)}
        />
        <TransactionDetailField
          label="Created"
          value={new Date(t.created_at).toLocaleString('en-GB', {
            dateStyle: 'medium',
            timeStyle: 'short',
          })}
        />
      </div>
      <div className="flex shrink-0 justify-end border-t border-[#e8e8e8] px-6 py-4">
        <Button variant="ghost" size="sm" onClick={onClose}>
          Close
        </Button>
      </div>
    </ReviewDialog>
  );
}
